import * as React from 'react';

import {
  NavigationProps,
} from './topnavgationprops';

/**
 *  Navigation Item displayed to top left of the header
 * @pops is passed contains Item as icon or label value.
 */
export const NavigationItem: any = (
  props: NavigationProps
) => {

  const {
    children,
    type,
    value,
    label,
  } = props;

  let renderui;
  if (type && type === "logo") {
    renderui = (
      <div className="top-navigation__item ">
        <div className="top-navigation__item-a"> {children}</div>

      </div>
    )
  } else {
    renderui = (
      <div className="top-navigation__item" key={label}>
        <div className="top-navigation__item-a">{label}:</div>
        <div className="top-navigation__item-b">{value}</div>
      </div>
    );
  }
  return (
    <>
      {
        renderui
      }
    </>
  )
};
